import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Error } from "../../../../commons/Messages/Messages";
import { Tabs, Card, Avatar, Descriptions, Badge, Tag, Flex, Typography } from "antd";
import { UserOutlined } from "@ant-design/icons";
import "./Profile.css";
import { EmpShifts } from "../../../../commons/Employees/EmpShifts/EmpShifts";
import EmployeLeaves from "../../../../commons/Employees/EmployeLeaves/EmployeLeaves";
import EmployeeTasks from "./Tasks/EmployeeTasks";
import EmployeeProjects from "./Projects/EmployeeProjects";
import EmployeeContracts from "./Contracts/EmployeeContracts";
import AttendanceComp from "../../../../commons/Employees/Attendance/AttendanceComp";
import AppointmentsCalendar from "../../../../commons/Appointments/AppointmentsCalendar";
import SalarySlipsList from "../../../../commons/Employees/SalarySlips/SalarySlips";
import dayjs from "dayjs";
import EmployeeAssets from "../../../../commons/Employees/AssetsManagement/EmployeeAssets";
import EmployeeSafety from "../../safety/EmployeeSafety";
import { hasPermission } from "../../../../commons/Permissions/PermissionsHook";
import { UserContext } from "../../../../context/UserContext";

import { useTranslation } from "react-i18next";
const EmployeesProfile = () => {
  const { t } = useTranslation("dashboard");
  const [user, setUser] = useState([]);
  const params = useParams();
  const currentUser = useContext(UserContext);

  const getUser = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/employees/employee/${params?.id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setUser(res.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        Error(err.message);
      });
  };

  useEffect(() => {
    params?.id && getUser();

    return () => {};
  }, [params?.id]);
  const DescriptionItems = [
    {
      key: "3",
      label: t("Employee ID"),
      children: user?.employeeId || "N/A"
    },
    {
      key: "1",
      label: t("BirthDate"),
      children: dayjs(user?.birthDate, "DD/MMM/YYYY").format("DD/MMM/YYYY") || "N/A"
    },
    {
      key: "2",
      label: t("Joining Date"),
      children: dayjs(user?.joiningDate, "DD/MMM/YYYY").format("DD/MMM/YYYY") || "N/A"
    },
    {
      key: "4",
      label: t("Department"),
      children: user?.department?.title || "N/A"
    },
    {
      key: "5",
      label: t("Designation"),
      children: user?.designation?.title || "N/A"
    },
    {
      key: "6",
      label: t("Marital Status"),
      children: user?.maritalStatus || "N/A"
    },
    {
      key: "7",
      label: t("Number Of Kids"),
      children: user?.numberOfKids || "N/A"
    },
    {
      key: "8",
      label: t("Email"),
      children: user?.email || "N/A"
    },
    {
      key: "9",
      label: t("Phone"),
      children: user?.phone || "N/A"
    },
    {
      key: "10",
      label: t("Address"),
      children:
        `${user?.street || ""} ${user?.streetNumber || ""}, ${user?.zipCode || ""} ${user?.city || ""}, ${user?.state || ""} ${user?.country || ""}`.trim() ||
        "N/A"
    },
    {
      key: "11",
      label: t("Status"),
      children: (
        <Badge
          status={user?.status === "inActive" ? "error" : "success"}
          text={user?.status || "N/A"}
        />
      )
    }
  ];

  const tabsItems = [
    {
      key: "1",
      label: t("Overview"),
      children: (
        <Card>
          <Flex vertical align="center" gap={8} className="employee-profile__summary">
            <Avatar
              className="employee-profile-avatar"
              size={64}
              src={user?.picture?.url || <UserOutlined />}
              alt="User Picture"
            />
            <Typography.Title level={5} className="employee-profile__name">
              {user?.firstName} {user?.lastName}
            </Typography.Title>
            <Flex wrap="wrap" justify="center" gap={6}>
              <Tag bordered={false}>{user?.designation?.title || "N/A"}</Tag>
              <Tag bordered={false}>
                {user?.experience || "N/A"} {t("Experience")}
              </Tag>
            </Flex>
          </Flex>
          <Descriptions
            className="employee-profile__details"
            title={t("Personal Information")}
            bordered
            items={DescriptionItems}
            layout="vertical"
            column={{ xs: 1, sm: 2, lg: 3 }}
          />
        </Card>
      )
    },
    {
      key: "2",
      label: t("Contracts"),
      children: <EmployeeContracts employeeObject={user} />
    },
    {
      key: "3",
      label: t("Inventory"),
      children: <EmployeeAssets employeeObject={user} />
    },
    {
      key: "4",
      label: t("Shifts"),
      children: <EmpShifts employeeObject={user} />
    },
    {
      key: "5",
      label: t("Appointments"),
      children: <AppointmentsCalendar employeeId={user?._id} />
    },
    {
      key: "6",
      label: t("Tasks"),
      children: <EmployeeTasks employeeObject={user} />
    },
    {
      key: "7",
      label: t("Working Hours"),
      children: <AttendanceComp employeeId={user?._id} />
    },
    {
      key: "8",
      label: t("Leaves"),
      children: <EmployeLeaves employeeObject={user} />
    },
    {
      key: "9",
      label: t("Projects"),
      children: <EmployeeProjects employeeObject={user} />
    },
    {
      key: "10",
      label: t("Salary Slips"),
      children: <SalarySlipsList employee={user} />
    },
    hasPermission(currentUser?.permissions, "Safety", "Read") && {
      key: "11",
      label: t("Safety"),
      children: <EmployeeSafety employeeId={user?._id} />
    }
  ].filter(Boolean);

  return (
    <>
      <div className="EmployeesProfile">
        <Tabs defaultActiveKey="1" items={tabsItems} className="antd-tabs1" />
      </div>
    </>
  );
};

export default EmployeesProfile;
